import React from 'react';
import PropTypes from 'prop-types';
import { SnackbarContent, IconButton, Icon } from '@material-ui/core';

const styles = {
  message: {
    margin: '10px 10px 0 10px',
  },
  messageSmall: {
    margin: '0 0 10px 0',
  },
};

const levels = {
  info: undefined,
  error: '#d32f2f',
  warning: '#ffa000',
};

const Message = (props) => {
  const {
    useDesktopLayout, message, level, onClose,
  } = props;

  const style = {
    ...(useDesktopLayout ? styles.message : styles.messageSmall),
    backgroundColor: levels[level],
  };

  return (
    <SnackbarContent
      style={style}
      message={
        <div>{message}</div>
      }
      action={[
        <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
          <Icon>close</Icon>
        </IconButton>,
      ]}
    />
  );
};

Message.propTypes = {
  message: PropTypes.string,
  level: PropTypes.string,
  useDesktopLayout: PropTypes.bool,
  onClose: PropTypes.func,
};

Message.defaultProps = {
  message: '',
  level: '',
  useDesktopLayout: true,
  onClose: () => {},
};


export default Message;
